// extracted by mini-css-extract-plugin
export default {"typesRow":"Types_typesRow__6zLqV","container":"Types_container__Zkbes","title":"Types_title__7-RYj","description":"Types_description__X7yRW"};